/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { useTranslation } from 'react-i18next';

import Text from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function Step3Personal({
  name,
  industry,
  telephoneNumber,
  onUpdate,
  newsletter,
}) {
  const { t } = useTranslation();

  return (
    <div>
      <Text
        variant="h6"
        fontWeight="700"
        css={css`
          min-height: 48px;
        `}
      >
        {t('Dina kontaktuppgifter')}
      </Text>
      <TextField
        label={t('Namn')}
        variant="outlined"
        placeholder={t('För- och efternamn')}
        sx={{ width: '100%', marginTop: '0.8rem' }}
        autoComplete="off"
        value={name}
        onChange={(e) => onUpdate({ name: e.target.value })}
        size="small"
      />
      <TextField
        label={t('Telefonnummer')}
        autoComplete="off"
        sx={{ width: '100%', marginTop: '0.8rem' }}
        value={telephoneNumber}
        onChange={(e) => onUpdate({ telephoneNumber: e.target.value })}
        size="small"
      />
      <FormControlLabel
        sx={{ marginTop: '1rem' }}
        control={<Checkbox />}
        label={t(
          'Jag vill få praktiska tips, produktuppdateringar och information om Klang via e-post'
        )}
        value={newsletter}
        checked={newsletter}
        onChange={(e) => onUpdate({ newsletter: e.target.checked })}
      />
    </div>
  );
}
